module.exports = __webpack_public_path__ + "c8f917e57e319a40b2b9b5e8eb94919d.svg";